import clsx from 'clsx'
import React from 'react'

import { Price } from '@/components/Price'

type Props = {
  amount: number
  position?: 'bottom' | 'center'
  title: string
}

export const Label: React.FC<Props> = ({ amount, position = 'bottom', title }) => {
  return (
    <div
      className={clsx('flex w-full px-4 pb-4 pt-2 @container/label', {
        '': position === 'center',
      })}
    >
      <div className="flex flex-col items-start gap-2 w-full">
        <h3 className="font-mono text-sm leading-tight tracking-tight text-black dark:text-white line-clamp-2">
          {title}
        </h3>

        <Price
          amount={amount}
          className="flex-none rounded-full bg-black dark:bg-white p-2 text-white dark:text-black font-mono text-xs border border-neutral-200 dark:border-neutral-800"
          currencyCodeClassName="hidden @[275px]/label:inline"
        />
      </div>
    </div>
  )
}
